<template>
  <v-card flat class="content-visibility-auto mb-2 pa-0">
    <v-card-title class="title pa-0 justify-center">
      <v-toolbar flat>
        <v-toolbar-title>
          Calendar
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon flat color="primary" small @click="openAddReminder">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn icon @click="$refs.calendar.prev()" flat color="primary">
          <v-icon>
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-menu
          ref="calendarDatepickerMenu"
          v-model="calendarDatepickerMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="calendarToday"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="text-truncate caption">
              {{ calendarToday.substring(0, 7) }}
            </span>
          </template>
          <v-date-picker v-model="calendarToday" no-title scrollable color="primary">
            <v-spacer></v-spacer>
            <v-btn icon @click="calendarDatepickerMenu = false">
              <v-icon color="error">
                mdi-close
              </v-icon>
            </v-btn>
            <v-btn icon @click="jumptToToday">
              <v-icon color="accent">
                mdi-calendar-today
              </v-icon>
            </v-btn>
            <v-btn icon @click="$refs.calendarDatepickerMenu.save(calendarToday)">
              <v-icon color="primary">
                mdi-check
              </v-icon>
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-btn icon @click="$refs.calendar.next()" flat color="primary">
          <v-icon>
            mdi-chevron-right
          </v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              color="primary"
              v-on="on">
              <v-icon>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile
              v-for="t in [
                { item: 'Zilnic', value: 'day' },
                { item: 'Saptamanal', value: 'week' },
                { item: 'Lunar', value: 'month' }
              ]"
              :key="t.value"
              @click="setCalendarType(t.value)">
              <v-list-tile-action>
                <v-icon v-if="calendarType === t.value">mdi-check</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ t.item }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-card-title>
    <v-divider class="my-2"></v-divider>
    <v-card-text class="pa-0">
      <div class="d-flex my-2 text-xs-center">
        <span>
          <v-icon small :color="$vuetify.theme.success" size="12">
            mdi-check-circle
          </v-icon>
          <v-icon small :color="$vuetify.theme.success" size="12">
            mdi-circle-outline
          </v-icon>
          lift
        </span>
        <span>
          <v-icon small :color="$vuetify.theme.info" size="12">
            mdi-check-circle
          </v-icon>
          <v-icon small :color="$vuetify.theme.info" size="12">
            mdi-circle-outline
          </v-icon>
          obiectiv
        </span>
        <span>
          <v-icon small :color="$vuetify.theme.warning" size="12">
            mdi-check-circle
          </v-icon>
          <v-icon small :color="$vuetify.theme.warning" size="12">
            mdi-circle-outline
          </v-icon>
          poze
        </span>
        <span>
          <v-icon small :color="$vuetify.theme.error" size="12">
            mdi-check-circle
          </v-icon>
          <v-icon small :color="$vuetify.theme.error" size="12">
            mdi-circle-outline
          </v-icon>
          documente
        </span>
        <span>
          <v-icon small color="grey" size="12">
            mdi-check-circle
          </v-icon>
          <v-icon small color="grey" size="12">
            mdi-circle-outline
          </v-icon>
          nespecificat
        </span>
      </div>
      <v-calendar
        v-model="calendarToday"
        ref="calendar"
        color="primary"
        locale="ro-ro"
        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
        :type="calendarType"
        @click:date="dateClick"
        @click:day="dayClick">
        <!-- month view, day cell content -->
        <template v-slot:day="{ date }">
          <div class="d-flex" style="flex-wrap: wrap; justify-content: space-around;">
            <template v-for="(item, index) in remindersForDate(date)">
              <v-icon size="15" :color="reminderColor(item)" :key="index">
                {{ item.is_done ? 'mdi-check-circle' : 'mdi-circle-outline' }}
              </v-icon>
            </template>
          </div>
        </template>
        <!-- week and day view, header content -->
        <template v-slot:dayHeader="{ date }">
          <template v-if="remindersForDate(date).length">
            <template v-if="calendarType === 'week'">
              <v-icon size="15" class="ml-2">
                mdi-circle
              </v-icon>
              {{ remindersForDate(date).length }}
            </template>
            <template v-else>
              <template v-for="(item, index) in remindersForDate(date)">
                <v-icon size="18" class="ml-2" :color="reminderColor(item)" :key="index">
                  {{ item.is_done ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                </v-icon>
              </template>
            </template>
          </template>
        </template>
        <!-- week and day view, interval content -->
        <template v-slot:interval="{ date, time }">
          <template v-if="calendarType === 'week' && remindersForDateTime(date, time).length">
            <div style="height: 100%; display: flex; align-items: center; justify-content: center;">
              <v-icon size="15" class="mr-1">
                mdi-circle
              </v-icon>
              {{ remindersForDateTime(date, time).length }}
            </div>
          </template>
          <div class="d-flex pa-1" style="width: 100%; overflow-x: auto" v-if="calendarType === 'day'">
            <template v-for="(item, index) in remindersForDateTime(date, time)">
              <v-chip small :key="index" :color="reminderColor(item)" @click="openViewReminder(item)">
                <v-avatar>
                  <v-icon>
                    {{ item.is_done ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                  </v-icon>
                </v-avatar>
                {{ item.title }}
              </v-chip>
            </template>
          </div>
        </template>
      </v-calendar>

      <template v-if="calendarType === 'month'">
        <h1 class="title text-capitalize mt-4">
          {{ new Date(calendarToday).toLocaleDateString('ro-ro', { month: 'long', year: 'numeric' }) }}
        </h1>
        <v-list two-line dense>
          <template v-for="day in daysWithReminders">
            <v-subheader :key="day">
              {{ new Date(day).toLocaleDateString('ro-ro', { weekday: 'long', day: 'numeric', month: 'long' }) }}
            </v-subheader>

            <template v-for="item in remindersForDate(day)">
              <v-divider inset :key="item._id + ' divider'" class="my-2"></v-divider>
              <v-list-tile avatar :key="item._id + ' item'" @click="openViewReminder(item)">
                <v-list-tile-avatar>
                  <v-icon :color="reminderColor(item)">
                    <template v-if="item.type === 'lift'">
                      mdi-elevator
                    </template>
                    <template v-else-if="item.type === 'obiectiv'">
                      mdi-domain
                    </template>
                    <template v-else-if="item.type === 'poze'">
                      mdi-camera
                    </template>
                    <template v-else-if="item.type === 'documente'">
                      mdi-file-document
                    </template>
                    <template v-else>
                      mdi-help-circle
                    </template>
                  </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ item.user_id.username }}
                    <template v-if="item.entity_id">
                      (Simbol: {{ item.entity_id.id_scara }})
                    </template>
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>{{ new Date(item.start_date).toLocaleString('ro-ro', { hour: '2-digit', minute: '2-digit' }) }}</v-list-tile-action-text>
                  <!-- <v-icon :color="item.is_done ? 'primary' : 'gray'">
                    {{ item.is_done ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}
                  </v-icon> -->
                  <v-icon :color="item.is_done ? 'primary' : 'grey'">
                    {{ item.is_done ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </template>

        </v-list>
      </template>
    </v-card-text>

    <!-- add reminder dialog -->
    <v-dialog persistent max-width="80vw" :transition="false" no-click-animation hide-overlay v-model="addReminderDialog">
      <v-card flat>
        <v-card-title class="title">
          Adauga reminder
        </v-card-title>
        <v-card-text>
          <v-layout column>
            <!-- user select -->
            <v-flex>
              <v-select
                v-model="newReminder.user_id"
                prepend-icon="mdi-account"
                :items="users"
                item-text="username"
                item-value="_id"
                label="Utilizator"
                :disabled="user.dummy">
                <template v-slot:selection="{ item }">
                  <v-list-tile-avatar>
                    <v-icon>
                      <template v-if="item.admin">
                        mdi-shield-crown
                      </template>
                      <template v-else-if="item.user">
                        mdi-camera
                      </template>
                      <template v-else-if="item.excel">
                        mdi-file-excel
                      </template>
                      <template v-else-if="item.pdf">
                        mdi-file-pdf-box
                      </template>
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.username }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar>
                    <v-icon :color="item.color">
                      mdi-circle-medium
                    </v-icon>
                  </v-list-tile-avatar>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-tile-avatar>
                    <v-icon>
                      <template v-if="item.admin">
                        mdi-shield-crown
                      </template>
                      <template v-else-if="item.user">
                        mdi-camera
                      </template>
                      <template v-else-if="item.excel">
                        mdi-file-excel
                      </template>
                      <template v-else-if="item.pdf">
                        mdi-file-pdf-box
                      </template>
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.username }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar>
                    <v-icon :color="item.color">
                      mdi-circle
                    </v-icon>
                  </v-list-tile-avatar>
                </template>
              </v-select>
            </v-flex>
            <!-- entity -->
            <v-flex>
              <v-autocomplete
                v-model="newReminder.entity_id"
                :items="allEntities"
                item-text="id_scara"
                item-value="_id"
                label="Simbol"
                clearable
                placeholder="neatribuit - reminder general"
                prepend-icon="mdi-domain">
                <template v-slot:selection="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.id_scara }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-tile-avatar>
                    <v-icon>
                      mdi-domain
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item.id_scara }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ item.adresa }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <!-- type -->
            <v-flex>
              <v-select
                v-model="newReminder.type"
                prepend-icon="mdi-format-list-bulleted-type"
                :items="reminderTypes"
                label="Tip"
                :disabled="user.dummy">
                <template v-slot:selection="{ item }">
                  <v-list-tile-avatar>
                    <v-icon v-if="item === 'lift'">
                      mdi-elevator
                    </v-icon>
                    <v-icon v-else-if="item === 'obiectiv'">
                      mdi-domain
                    </v-icon>
                    <v-icon v-else-if="item === 'poze'">
                      mdi-camera
                    </v-icon>
                    <v-icon v-else-if="item === 'documente'">
                      mdi-file-document
                    </v-icon>
                    <v-icon v-else>
                      mdi-help-circle
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar>
                    <v-icon :color="reminderColor({ type: item })">
                      mdi-circle-medium
                    </v-icon>
                  </v-list-tile-avatar>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-tile-avatar>
                    <v-icon v-if="item === 'lift'">
                      mdi-elevator
                    </v-icon>
                    <v-icon v-else-if="item === 'obiectiv'">
                      mdi-domain
                    </v-icon>
                    <v-icon v-else-if="item === 'poze'">
                      mdi-camera
                    </v-icon>
                    <v-icon v-else-if="item === 'documente'">
                      mdi-file-document
                    </v-icon>
                    <v-icon v-else>
                      mdi-help-circle
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ item }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-avatar>
                    <v-icon :color="reminderColor({ type: item })">
                      mdi-circle
                    </v-icon>
                  </v-list-tile-avatar>
                </template>
              </v-select>
            </v-flex>
            <!-- title textfield -->
            <v-flex>
              <v-text-field
                @input="setField($event, 'title', 'newReminder')"
                :value="newReminder.title"
                prepend-icon="mdi-format-title"
                label="Titlu"
                :disabled="user.dummy">
              </v-text-field>
            </v-flex>
            <!-- description textarea -->
            <v-flex>
              <v-textarea
                @input="setField($event, 'description', 'newReminder')"
                :value="newReminder.description"
                prepend-icon="mdi-text"
                label="Descriere"
                :disabled="user.dummy">
              </v-textarea>
            </v-flex>
            <!-- date datepicker -->
            <v-flex>
              <v-menu
                ref="newReminderDateMenu"
                v-model="newReminderDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formattedDate"
                    label="Data"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :disabled="user.dummy">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="newReminder.start_date"
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="newReminderDateMenu = false">
                    <v-icon color="error">
                      mdi-close
                    </v-icon>
                  </v-btn>
                  <v-btn icon @click="$refs.newReminderDateMenu.save(newReminder.start_date)">
                    <v-icon color="primary">
                      mdi-check
                    </v-icon>
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <!-- time picker -->
            <v-flex>
              <v-menu
                ref="newReminderTimeMenu"
                v-model="newReminderTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="newReminder.start_time"
                    label="Ora"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                    :disabled="user.dummy">
                  </v-text-field>
                </template>
                <v-time-picker
                  v-model="newReminder.start_time"
                  format="24hr"
                  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="newReminderTimeMenu = false">
                    <v-icon color="error">
                      mdi-close
                    </v-icon>
                  </v-btn>
                  <v-btn icon @click="$refs.newReminderTimeMenu.save(newReminder.start_time)">
                    <v-icon color="primary">
                      mdi-check
                    </v-icon>
                  </v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddReminderDialog(false)">Renunta</v-btn>
          <v-btn flat color="primary" @click="closeAddReminderDialog(true)" :disabled="!validNewReminder">Salveaza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- view reminder dialog -->
    <v-dialog persistent max-width="80vw" :transition="false" no-click-animation hide-overlay v-model="viewReminderDialog">
      <v-card v-if="viewReminder">
        <v-card-title style="flex-wrap: nowrap;">
          <v-icon v-if="viewReminder.type === 'lift'">
            mdi-elevator
          </v-icon>
          <v-icon v-else-if="viewReminder.type === 'obiectiv'">
            mdi-domain
          </v-icon>
          <v-icon v-else-if="viewReminder.type === 'poze'">
            mdi-camera
          </v-icon>
          <v-icon v-else-if="viewReminder.type === 'documente'">
            mdi-file-document
          </v-icon>
          <v-icon v-else>
            mdi-help-circle
          </v-icon>

          <span class="text-truncate title ml-2">
            {{ viewReminder.title }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeViewReminder">
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-container grid-list-xl text-xs-left fluid class="pa-0">
            <v-layout row wrap align-center>
              <v-flex xs4>
                <v-icon size="18">
                  mdi-clock
                </v-icon>
                {{ new Date(viewReminder.start_date).toLocaleTimeString('ro-ro', { hour: '2-digit', minute: '2-digit' }) }}
              </v-flex>

              <v-flex xs4>
                <v-icon size="18">
                  mdi-account
                </v-icon>
                {{ viewReminder.user_id.username }}
              </v-flex>

              <v-flex xs4 v-if="viewReminder.entity_id">
                <v-icon size="18">
                  mdi-domain
                </v-icon>
                {{ viewReminder.entity_id.id_scara }}
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center>
              <v-flex xs12 style="max-height: 50vh; overflow-y: auto">
                {{ viewReminder.description }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat :icon="!isDeleting" :diabled="!user.admin || user._id !== viewReminder.owner_id" @click="deleteReminder">
            <v-icon color="error" :left="isDeleting">
              mdi-delete
            </v-icon>
            <span v-if="isDeleting">Confirma</span>
          </v-btn>
          <v-btn flat :icon="!isToggling" @click="toggleReminderDone">
            <v-icon :left="isToggling" :color="viewReminder.is_done ? 'primary' : 'gray'">
              {{ viewReminder.is_done ? 'mdi-check-circle' : 'mdi-circle-outline' }}
            </v-icon>
            <span v-if="isToggling">Confirma</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  name: 'Reminders',
  data: () => ({
    calendarDatepickerMenu: false,
    calendarType: 'month',
    calendarToday: new Date().toISOString().substring(0, 10),

    addReminderDialog: false,
    newReminderDateMenu: false,
    newReminderTimeMenu: false,
    reminderTypes: ['obiectiv', 'lift', 'poze', 'documente', 'alte'],
    newReminder: {
      user_id: null,
      entity_id: null,
      type: null,
      title: null,
      description: null,
      start_date: null,
      start_time: null
    },

    viewReminderDialog: false,
    viewReminder: null,
    isDeleting: false,
    isToggling: false,
    deleteReminderTimeout: null,
    toggleReminderTimeout: null
  }),

  watch: {
    calendarToday: {
      immediate: true,
      handler (newVal, oldVal) {
        this.fetchReminders(newVal, oldVal)
      }
    },
    activeEntity: {
      immediate: true,
      handler () {
        this.fetchReminders()
      }
    }
  },

  computed: {
    activeEntity () {
      return this.$store.getters['entities/activeEntity']
    },
    user () {
      return this.$store.getters.user
    },
    users () {
      return this.$store.getters.users
    },
    formattedDate () {
      return this.newReminder.start_date ? new Date(this.newReminder.start_date).toLocaleDateString('ro-Ro', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : ''
    },
    validNewReminder () {
      return !!(this.newReminder.user_id &&
        // this.newReminder.entity_id &&
        this.newReminder.start_date &&
        this.newReminder.start_time &&
        this.newReminder.title &&
        this.newReminder.description &&
        this.newReminder.type)
    },
    reminders () {
      return this.$store.getters.reminders
    },
    daysWithReminders () {
      // returns a set of days that have reminders
      return Array.from(new Set(this.reminders.map(r => r.start_date.substring(0, 10))).values())
    },
    allEntities () {
      return this.$store.getters['entities/allItems']
    }
  },

  methods: {
    fetchReminders: debounce(function (newToday = null, oldToday = null) {
      // console.log('fecthing reminders')
      if (this.$route.name === 'details' && !this.activeEntity) return

      if (this.calendarToday) {
        const entity = this.activeEntity ? this.activeEntity._id : null
        const date = this.calendarToday

        if (oldToday) {
          const oldMonth = oldToday.substring(0, 7)
          const newMonth = newToday.substring(0, 7)

          if (oldMonth !== newMonth) {
            this.$store.dispatch('fetchReminders', { entity, date })
          }
        } else {
          this.$store.dispatch('fetchReminders', { entity, date })
        }
      }
    }, 500),
    openAddReminder () {
      let userId = this.user._id
      let entityId = this.activeEntity ? this.activeEntity._id : null

      if (this.$route.name === 'details') {
        if (this.user.admin && this.activeEntity && this.activeEntity.user) {
          const user = this.users.find(u => u.username === this.activeEntity.user)
          userId = user ? user._id : this.user._id
        }
      }

      if (this.calendarType === 'day') {
        this.newReminder.start_date = this.calendarToday
      }

      this.newReminder.user_id = userId
      this.newReminder.entity_id = entityId
      this.newReminder.type = 'obiectiv'

      this.addReminderDialog = true
    },
    async closeAddReminderDialog (mode) {
      if (mode) {
        const newReminder = {
          user_id: this.newReminder.user_id,
          entity_id: this.newReminder.entity_id || null,
          type: this.newReminder.type,
          title: this.newReminder.title,
          description: this.newReminder.description,
          start_date: this.newReminder.start_date + ' ' + this.newReminder.start_time
        }

        await this.$store.dispatch('saveReminder', newReminder)
        this.fetchReminders()
      }

      this.newReminder.user_id = null
      this.newReminder.entity_id = null
      this.newReminder.type = null
      this.newReminder.title = null
      this.newReminder.description = null
      this.newReminder.start_date = null
      this.newReminder.start_time = null

      this.addReminderDialog = false
    },
    dayClick ({ date }) {
      // only occurs on month view
      this.calendarToday = date
      this.calendarType = 'week'
    },
    dateClick ({ date }) {
      // occurs on all views
      this.calendarToday = date
      if (this.calendarType === 'day') {
        this.calendarType = 'month'
      } else {
        this.calendarType = 'day'
      }
    },
    jumptToToday () {
      this.calendarToday = new Date().toISOString().substring(0, 10)
    },
    remindersForDate (date) {
      return this.reminders
        .filter(reminder => reminder.start_date.substring(0, 10) === date)
        .sort((a, b) => a.start_date.substring(11, 16) > b.start_date.substring(11, 16) ? 1 : -1)
    },
    remindersForDateTime (date, time) {
      const slotDate = `${date} ${time}`
      return this.reminders
        .filter(reminder => {
          // converting it to a date object to get the correct date with locale
          const r = new Date(reminder.start_date)
          const reminderDate = `${r.getFullYear()}-${String(r.getMonth() + 1).padStart(2, '0')}-${String(r.getDate()).padStart(2, '0')} ${String(r.getHours()).padStart(2, '0')}:00`

          return reminderDate === slotDate
        })
        .sort((a, b) => a.start_date > b.start_date ? 1 : -1)
    },
    reminderColor (item) {
      switch (item.type) {
        case 'lift':
          return this.$vuetify.theme.success
        case 'obiectiv':
          return this.$vuetify.theme.info
        case 'poze':
          return this.$vuetify.theme.warning
        case 'documente':
          return this.$vuetify.theme.error
        default:
          return 'grey'
      }
    },
    setCalendarType (type) {
      this.calendarType = type
    },

    setField ($value, field, parent = null, index = null, number = false) {
      if (this.user.dummy) return
      if (parent) {
        if (index === null) {
          this[`set_${field}_${parent}`](number ? (isNaN($value) ? null : +$value) : $value)
        } else {
          this[`set_${field}_${parent}_${index}`](number ? (isNaN($value) ? null : +$value) : $value)
        }
      } else {
        this[`set_${field}`](number ? (isNaN($value) ? null : +$value) : $value)
      }
    },

    set_title_newReminder: debounce(function (value) {
      this.$set(this.newReminder, 'title', value)
    }, 1000),
    set_description_newReminder: debounce(function (value) {
      this.$set(this.newReminder, 'description', value)
    }, 1000),

    openViewReminder (item) {
      this.viewReminder = item
      this.viewReminderDialog = true
    },
    closeViewReminder () {
      this.viewReminder = null
      this.viewReminderDialog = false
      this.isDeleting = false
      this.isToggling = false
    },
    async deleteReminder () {
      if (this.isDeleting) {
        clearTimeout(this.deleteReminderTimeout)
        await this.$store.dispatch('deleteReminder', { _id: this.viewReminder._id })
        this.fetchReminders()
        this.closeViewReminder()
      } else {
        this.isDeleting = true
        this.deleteReminderTimeout = setTimeout(() => {
          this.isDeleting = false
        }, 3000)
      }
    },
    async toggleReminderDone () {
      if (this.isToggling) {
        clearTimeout(this.toggleReminderTimeout)
        await this.$store.dispatch('toggleReminderDone', { _id: this.viewReminder._id, done: !this.viewReminder.is_done })
        this.fetchReminders()
        this.closeViewReminder()
      } else {
        this.isToggling = true
        this.toggleReminderTimeout = setTimeout(() => {
          this.isToggling = false
        }, 3000)
      }
    }
  },

  mounted () {
    if (this.$route.name === 'reminders') {
      this.$store.dispatch('fetchUsers')
    }
    // not working
    // const nowTime = new Date().toISOString().substring(11, 16)
    // this.$refs.calendar.scrollToTime(nowTime)
  },

  beforeDestroy () {
    this.$store.commit('setReminders', [])
  }
}
</script>

<style>

</style>
